import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.license-violations', {
        url: '/violations',
        component: 'licenseViolations',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/license-violations/license-violations.state.js